import { Box } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import AddButtonRounded from '@Components/AddButtonRounded';
import { useDisclosure } from '@hooks/useDisclosure';
import { useNatureOfBusinessForm } from '@Router/NatureOfBusiness/Containers/NatureOfBusinessFormProvider';
import { INCOME_SUBGROUP_CATEGORY } from 'src/Enum/IncomeStructure';
import OtherIncomeModal from '../OtherIncomeModal/OtherIncomeModal';
import { IIncomeStructureFormValues } from '@Router/NatureOfBusiness/Containers/NatureOfBusinessFormProvider/types';

type OtherIncomeAddButtonProps = {
  subgroup: INCOME_SUBGROUP_CATEGORY;
};

const OtherIncomeAddButton = ({ subgroup }: OtherIncomeAddButtonProps) => {
  const [opened, { open, close }] = useDisclosure();
  const { watch } = useNatureOfBusinessForm();

  const completedSection = watch(
    'incomeStructure.completedSection'
  ) as IIncomeStructureFormValues['completedSection'];
  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  return (
    <>
      <Flex gap={1} mt={2}>
        <Box width={1} minWidth={235} maxWidth={350} />
        <Box
          ml={1}
          width={1}
          display={'grid'}
          gridTemplateColumns={'1fr'}
          gap={3}
        >
          <AddButtonRounded
            name={
              subgroup === INCOME_SUBGROUP_CATEGORY.OTHER_OPERATION_INCOME
                ? 'แจกแจงรายได้อื่นจากการดำเนินงาน'
                : 'แจกแจงรายได้อื่นนอกเหนือจากการดำเนินงาน'
            }
            onClick={open}
            disabled={isCompletedTh || isCompletedEn}
          />
        </Box>
      </Flex>
      {opened && (
        <OtherIncomeModal
          subgroup={subgroup}
          mode="create"
          open={opened}
          close={close}
        />
      )}
    </>
  );
};

export default OtherIncomeAddButton;
